
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './principalsxyjhi.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pprincipalsxyjhi = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id693189cb8e5aed52dc8a8f7e" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
        <a
          target=""
          className=""
          id="iy755i"
          href="/"
        >
          
      <img
        className=""
        id="if44vv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
        </a>
        
      <div id="itmdc" className="">
      
        <a
          target=""
          className="link-menu "
          id="ifq58z"
          href="/sobrenosotros"
        >
          
    <div id="ih5vyw" className="">
    <>Quienes Somos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iayexh"
          href="/proyectos"
        >
          
    <div id="ivyd2m" className="">
    <>Proyectos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="id0dxr"
          href="/campanas"
        >
          
    <div id="ib4com" className="">
    <>Campañas</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iqt5fq"
          href="/impacto"
        >
          
    <div id="i8sby8" className="">
    <>Impacto Social</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="irreek"
          href="/convenios"
        >
          
    <div id="ix4l8m" className="">
    <>Convenios</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ieceoy"
          href="/transparencia"
        >
          
    <div id="i9yljl" className="">
    <>Transparencia</>
    </div>
    
        </a>
        
      </div>
      
        <a
          target=""
          className="boton-principal "
          id="ivsxrh"
          href="/contacto"
        >
          
    <div id="is818l" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/proyectos"
        type=""
      >
        <>Proyectos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/campanas"
        type=""
      >
        <>Campañas</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/impacto"
        type=""
      >
        <>Impacto social</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/convenios"
        type=""
      >
        <>Convenios</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/transparencia"
        type=""
      >
        <>Transparencia</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>Fundación Petrus</>
      </div>
      
      <div id="i05hla" className="">
      
      <div id="ieksy5" className="">
      
      </div>
      
      <div id="if5pi" className="">
      
      <img
        className=""
        id="iz9d4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirkrtbg.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div className="" id="igqyi">
        <>Productividad rural con enfoque social</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iohiym">
        <>Es una asociación de víctimas del conflicto y familias campesinas que impulsa proyectos agroproductivos, seguridad alimentaria y encadenamiento regional desde la Finca La Comuna, en Pereira (Risaralda).</>
      </div>
      
      <div id="i0tfl" className="">
      
      <div id="ibmw1v" className="">
      
      <img
        className=""
        id="iw6yh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiylrmog.png"
        alt="undefined"
      />
      
      <div className="" id="iow0jk">
        <>9,720</>
      </div>
      
      <div className="" id="ic14wh">
        <>árboles de cacao FINO AROMA sembrados</>
      </div>
      
      </div>
      
      <div id="i64wtl" className="">
      
      <img
        className=""
        id="ivvsrx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiylsliw.png"
        alt="undefined"
      />
      
      <div className="" id="iayd9x">
        <>20,000</>
      </div>
      
      <div className="" id="ixefu7">
        <>plántulas de cacao proyectadas en producción.</>
      </div>
      
      </div>
      
      <div id="ihe7ox" className="">
      
      <img
        className=""
        id="iyey4e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyltkzd.png"
        alt="undefined"
      />
      
      <div className="" id="ifn4v3">
        <>19</>
      </div>
      
      <div className="" id="ik9sm1">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i80qqh">
        <>asociaciones cacaoteras beneficiadas en el Eje Cafetero.</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ihp4ya" className="">
      
      <img
        className=""
        id="i8oyp7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyluomy.png"
        alt="undefined"
      />
      
      <div className="" id="iyimg3">
        <>182,000+</>
      </div>
      
      <div className="" id="i195o5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilbosi">
        <>productores agropecuarios potencialmente impactados a través del proyecto RIS 004.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i7qj2" className="">
      
      <img
        className=""
        id="ihtiqg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirkyrzw.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div id="ikse2e" className="">
      
      <div id="iuzglb" className="">
      
      <div className="" id="ii5v25">
        <>Por qué trabajamos</>
      <br className="" id="" />
      
      </div>
      
      <div className="texto-secundario " id="iqfsim">
        <>Nuestro objetivo es mejorar la calidad de vida de las comunidades rurales, fortaleciendo la productividad agropecuaria, la asociatividad y la convivencia social. Lo hacemos mediante proyectos de cacao, plátano, sacha inchi, huertas comunitarias y procesos de certificación en Buenas Prácticas Agropecuarias y de Manufactura.</>
      </div>
      
      <div className="texto-secundario texto-separado " id="ir1n5h">
        <>1. </>
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ihbl8f">
        <>Solidaridad entre víctimas y campesinos</>
      </span>
      
      </div>
      
      <div className="texto-secundario texto-separado " id="ig5wot">
        <>2. </>
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivmoww">
        <>Trabajo asociativo y comunitario.</>
      </span>
      
      </div>
      
      <div className="texto-secundario texto-separado " id="iqz26s">
        <>3. </>
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iwnief">
        <>Respeto por la tierra y el medio ambiente</>
      </span>
      
      </div>
      
      <div className="texto-secundario texto-separado " id="izhc5k">
        <>4. </>
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iov7zd">
        <>Transparencia en la gestión de recursos.</>
      </span>
      
      </div>
      
        <a
          target=""
          className="boton-secundario "
          id="i72xtn"
          href="/sobrenosotros"
        >
          
    <div id="i27hxm" className="">
    <>Ver más</>
    </div>
    
        </a>
        
      </div>
      
      <div id="ill3zk" className="">
      
      <img
        className=""
        id="idbf4d"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirl48yw.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="izdkrq" className="">
      
      <div id="iou2cz" className="">
      
      <div id="iqpteu" className="">
      
      <img
        className=""
        id="iib6bz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirl734n.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i6wf3u" className="">
      
      <div className="" id="iucktz">
        <>Nuestro trabajo en el campo</>
      <br className="" id="" />
      
      </div>
      
      <div className="texto-secundario " id="iia64h">
        <>Desarrollamos cadenas productivas que combinan productividad, sostenibilidad y valor social para las familias campesinas de la Finca La Comuna y asociaciones aliadas del Eje Cafetero.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iuo301" className="">
      
      <div id="ihtmuj" className="">
      
      <div className="" id="iyijx2">
        <>Conectate con</>
      <br className="" id="" />
      <>Nosotros</>
      <br className="" id="" />
      
      </div>
      
      <div id="itnx4v" className="">
      
        <a
          target=""
          className="boton-principal "
          id="ivsxrh-2"
          href="/contacto"
        >
          
    <div id="is818l-2" className="">
    <>Más Información aqui</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i4gobj" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="ipvwpi">
        <>Fundación Petrus</>
      </div>
      
      <img
        className=""
        id="i3xw0h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="ion8vy" className="">
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Paginas</>
      </div>
      
      <div className="" id="igdgp1">
        <>Quienes Somos</>
      </div>
      
      <div className="" id="io8u0g">
        <>Proyectos</>
      </div>
      
      <div className="" id="i2qk4g">
        <>Impacto Social</>
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Más información</>
      </div>
      
      <div className="" id="i78qcc">
        <>Contacto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ia9g4u" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pprincipalsxyjhi);
  